import type { SuggestionSchema } from "app/pages/activation/components/Topics/types";

export enum ModalFlow {
    Add = "ADD",
    Edit = "EDIT",
    Delete = "DELETE",
    DeleteShared = "DELETE_SHARED",
    Advanced = "ADVANCED",
    Collision = "COLLISION",
}

export type ModalDataSchema<DataProps extends object = {}> = {
    modalFlow: ModalFlow;
    data?: DataProps;
};

export type TopicItemSchema = SuggestionSchema & { isSuggestion?: boolean };

export type NumOrStr = number | string;

type ModalSize = {
    width: NumOrStr;
    minHeight?: NumOrStr;
    maxHeight?: NumOrStr;
};

type ModalStyle = {
    padding?: NumOrStr;
    border?: string;
};

export type ModalConfig = {
    content: Required<Pick<ModalStyle, "padding" | "border">> & ModalSize;
};
